import { useState } from "react";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import BTBox from "../../components/BTBox";
import BTInput from "../../components/BTInput";
import BTButton from "../../components/BTButton";
import EnhancedTable from "../../components/BTTable";
import { CircularProgress } from "@mui/material";
import { Card } from "@mui/material";
import authService from "../../services/auth-service";
import moment from "moment";
import BTTypography from "../../components/BTTypography";
const Header = (props) => {
    const { setResults, setTableLoading } = props
    const [searchText, setSearchText] = useState("")
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false)
    const inputChange = (e) => {
        const { value } = e.target;
        setSearchText(value)
        setError("")
    }
    const callAgent = async () => {
        const payload = {
            attributes: {
                searchText
            }
        }
        try {
            setLoading(true)
            setTableLoading(true)
            const response = await authService.returns_ai_search(payload)
            if (response.status === 1) {
                if (response?.data?.clarification) {
                    setError(response?.data?.clarification?.question)
                }
                else {
                    setResults(response.data?.rows)
                }
            }
            else {

            }
        } catch (error) {
    
        }
        finally {
            setLoading(false)
            setTableLoading(false)
        }
    }
    return (
        <Card sx={{ width: "100%", padding: "1rem" }}>
            <BTBox sx={{ width: "100%" }}>
                <BTInput label="Ai Agent" fullWidth type="textarea" rows={4} multiline value={searchText} onChange={inputChange} />
                <BTBox mt={1} sx={{ display: "flex", justifyContent: error ? "space-between" : "flex-end", alignItems: "center" }}>
                    {error && <BTBox mt={1}>
                        <BTTypography variant="button" fontWeight="bold" textTransform={"capitalize"}>{error} 🤔</BTTypography>
                    </BTBox>}
                    <BTButton variant={"gradient"} color="dark" size="small" onClick={callAgent} disabled={loading}>
                        {loading ? <CircularProgress size={22} color="white" /> : "Make Search"}
                    </BTButton>
                </BTBox>

            </BTBox>
        </Card>
    )
}
const Contects = (props) => {
    const { results, tableLoading } = props

    const columns = [
        {
            id: "No.",
            name: "No.",
            selector: (row, index) => index + 1,
            width: "5%"
        },
        {
            id: "report_number",
            name: "Report Number",
            selector: (row) => row.report_number || "-",

        },
        {
            id: "customer_ref_no",
            name: "Customer Ref No",
            selector: (row) => row.customer_ref_no || "-",
        },
        {
            id: "other_report_number",
            name: "Other Report Number",
            selector: (row) => row.other_report_number || "-",

        },
        {
            id: "shape_name",
            name: "Shape",
            selector: (row) => row.shape_name || "-",

        },
        {
            id: "weight",
            name: "Weight",
            selector: (row) => row.weight || "-",

        },
        {
            id: "color_long",
            name: "Color",
            selector: (row) => row.color_long || "-",

        },
        {
            id: "clarity",
            name: "Clarity",
            selector: (row) => row.clarity || "-",
        },
        {
            id: "clarity_long",
            name: "Clarity Long",
            selector: (row) => row.clarity_long || "-",

        },
        {
            id: "cut_prop",
            name: "Cut",
            selector: (row) => row.cut_prop || "-",

        },
        {
            id: "fluorescence",
            name: "Fluorescence",
            selector: (row) => row.fluorescence || "-",

        },
        {
            id: "report_comment",
            name: "Comment",
            selector: (row) => row.report_comment || "-",

        },
        {
            id: "ret_bill_status",
            name: "Bill Status",
            selector: (row) => row.ret_bill_status || "-",

        },
        {
            id: "ret_type",
            name: "Type",
            selector: (row) => row.ret_type || "-",

        },
        {
            id: "ret_date",
            name: "Date",
            selector: (row) => moment(row.ret_date).format("DD/MM/YYYY") || "-",

        }

    ]

    return (
        <BTBox mt={1}>
            <EnhancedTable title="Agent Speaks 👍" columns={columns} rows={results} loading={tableLoading} />
        </BTBox>
    )
}
const AiAgent = () => {
    const [results, setResults] = useState([])
    const [tableLoading, setTableLoading] = useState(false)
    return <DashboardLayout>
        <Header setResults={setResults} setTableLoading={setTableLoading} />
        <Contects results={results} tableLoading={tableLoading} />
    </DashboardLayout>
}
export default AiAgent;